import SquigglyLine13Icon from '@/assets/icons/squiggly-lines/squiggly-line-13.svg?react';
import SquigglyLine6Icon from '@/assets/icons/squiggly-lines/squiggly-line-6.svg?react';
import capsuleImg from '@/assets/images/home/capsule.png';
import womenExerciseImg from '@/assets/images/home/women-exercise.png';
import { Button } from '@/components/common/Button';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { Link } from '@tanstack/react-router';

const planProperties = [
  {
    prop: 'Protein',
    value: '100-150g/day',
  },
  { prop: 'Movement', value: '3x/week' },
  { prop: 'Sleep', value: '7-9 hrs./night' },
];

export function PersonalizationSection() {
  const { isDesktop } = useBreakpoint();

  return (
    <Section
      containerClassName="lg:pb-2.5"
      className="flex flex-col lg:items-center"
    >
      <Heading
        as="h2"
        className="text-secondary mb-15 lg:mb-20 lg:max-w-100"
        underlinedText={isDesktop ? 'personal' : "It's personal"}
        underline={
          isDesktop ? (
            <SquigglyLine13Icon className="-bottom-4 -left-4.5" />
          ) : (
            <SquigglyLine6Icon className="-bottom-2" />
          )
        }
      >
        It's more than a plan. It's personal
      </Heading>

      <img
        src={womenExerciseImg}
        alt="Women Exercise"
        className="mb-10 lg:max-w-227.5"
      />

      <p className="text-secondary mb-10 lg:mb-12.5 lg:max-w-135.75">
        Get everything your body needs — in one simple pack, tailored to you. No
        guesswork, no clutter, just doctor-backed ingredients at the right dose,
        form, and time
      </p>

      {!isDesktop && (
        <div className="mb-11 flex flex-col gap-2">
          <div className="bg-primary text-primary-foreground flex items-center gap-2.5 rounded-[0.625rem] px-4 py-3">
            <img src={capsuleImg} alt="Capsule" className="w-17" />

            <div>
              <p className="mb-0.5 font-medium">Eternalife</p>
              <p className="text-sm">Kit 1</p>
            </div>
          </div>

          {planProperties.map(({ prop, value }) => (
            <div
              key={prop}
              className="bg-primary text-primary-foreground flex items-center justify-between rounded-[0.625rem] px-4 py-3.5"
            >
              <p className="font-medium">{prop}</p>
              <p className="text-sm">{value}</p>
            </div>
          ))}
        </div>
      )}

      <Button
        variant={isDesktop ? 'primary' : 'secondary'}
        className="self-center"
        asChild
      >
        <Link to={routes.auth.login}>
          {isDesktop ? 'Get started today' : 'Become a partner'}
        </Link>
      </Button>
    </Section>
  );
}
